<template>
  <div class="flex flex-col gap-y-3">
    <UserProfileSponsorSection
      v-if="!isLoading"
      title="establishmentMainInformation"
      panelTitle="establishmentMainInformation"
    >
      <template #sponsorType="{ profile }">
        {{ fetchMatchingEstablishmentProfile(profile.type) }}
      </template>
      <template #moreRows="{ profile }">
        <div class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5">
          <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
            {{ $t('LicenseExpiryDate') }}:
          </span>
          <span class="md:w-2/3">
            {{ profile.licenseExpiryDatePretty }}
          </span>
        </div>
        <div class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"></div>
        <div class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5">
          <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
            {{ $t('eChannelsSubscriptionDate') }}:
          </span>
          <span class="md:w-2/3">
            {{ profile.subscriptionStartDatePretty }}
          </span>
        </div>
        <div class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5">
          <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
            {{ $t('AmountOfSubscriptionSecurityDeposit') }}:
          </span>
          <span class="md:w-2/3">
            {{ profile.amountOfSubscriptionSecurityDeposit }}
          </span>
        </div>
        <div class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5">
          <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
            {{ $t('eChannelsExpiryDate') }}:
          </span>
          <span class="md:w-2/3">
            {{ profile.subscriptionEndDatePretty }}
          </span>
        </div>
      </template>
    </UserProfileSponsorSection>
  </div>
</template>

<script setup>
import UserProfileSponsorSection from '@/views/auth-user/user-profile/UserProfileSponsorSection.vue'
import { ref, onMounted } from 'vue'
import { useLookupsStore } from '@/stores/lookups'

const lookupsStore = useLookupsStore()

const establishmentTypes = ref()
const isLoading = ref(true)

onMounted(async () => {
  establishmentTypes.value = await lookupsStore.fetchLookup('/api/lookup/establishmentTypes')

  isLoading.value = false
})

const fetchMatchingEstablishmentProfile = (estType) => {
  return establishmentTypes.value.find((e) => e.id == estType).label
}
</script>

<script>
export default { name: 'EstProfileLanding' }
</script>

<style lang="scss" scoped></style>
